<template>
  <section class="container" id="contact">
    <div class="section-2">
      <div class="introduction" style="text-align: center;">
        <h4 style="justify-content: center;">Wanna talk?</h4>
        <p style="max-width: 550px; margin: 0 auto;">
          Have a cool project in mind, and think I can help you with it?
          Feel free to e-mail me and I shall get back to you as early as
          possible.
        </p>
        <a class="get-in-touch" href="mailto:shahid.sk27595@gmail.com">Get In Touch</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
    name: 'Contact'
};
</script>

<style>
</style>
